import React, { useState } from 'react';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';

const SettingsBlock = ({ title, subtitle, icon, children, defaultOpen = false }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="bg-white shadow sm:rounded-lg overflow-hidden">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors"
      >
        <div className="flex items-center space-x-3">
          {icon && <div className="text-gray-400">{icon}</div>}
          <div>
            <h2 className="text-lg font-medium text-gray-900">{title}</h2>
            {subtitle && <p className="mt-0.5 text-sm text-gray-500">{subtitle}</p>}
          </div>
        </div>
        {isOpen
          ? <FiChevronUp className="h-5 w-5 text-gray-400" />
          : <FiChevronDown className="h-5 w-5 text-gray-400" />
        }
      </button>
      {isOpen && (
        <div className="border-t border-gray-200 px-6 py-6">
          {children}
        </div>
      )}
    </div>
  );
};

export default SettingsBlock;
